import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import CustomLoader from "../common/Loader";
import { getProjectForms } from "../../services/projectService";
import { saveFormSettings, getForms } from "./../../services/formService";
import { toaster } from "../../config";
import * as Icon from 'react-feather';

class FormSettings extends Component {

    Forms = []

    constructor(props) {
        super(props);
        this.state = {
            show: this.props.show ? this.props.show : false,
            Widget_ID: 0,
            Form_CustomValidationSP: null,
            Form_ClienstSideRules: [],
            Form_BehaviorOnSave: '',
            Form_RedirectTo: null,
            Form_SaveButton: null,
            Form_CancelButton: null,
            loading: true,
            Form_ID: this.props.Form_ID ? this.props.Form_ID : 0
        }
        this.handleFormSettingsSave = this.handleFormSettingsSave.bind(this);
        this.handleDefaultButtonSwitch = this.handleDefaultButtonSwitch.bind(this);
    }

    async componentDidMount() {
        let { data: Forms } = await getProjectForms(this.props.Project_ID);
        const { data: allForms } = await getForms();
        this.Forms = Forms.filter((form) => form.Form_ID !== this.state.Form_ID);
        let currentForm = allForms.filter((form) => form.Form_ID == this.state.Form_ID);
        currentForm && this.setState({
            Form_BehaviorOnSave: currentForm[0].Form_BehaviorOnSave ? (currentForm[0].Form_BehaviorOnSave).toString() : '',
            Form_RedirectTo: currentForm[0].Form_RedirectTo || null,
            Form_CustomValidationSP: currentForm[0].Form_CustomValidationSP || null,
            Form_ClienstSideRules : currentForm[0].Form_ClienstSideRules === 'None' ? [] : eval(currentForm[0].Form_ClienstSideRules) || [],
            Form_SaveButton: currentForm[0].Form_SaveButton_disable === 'True' || null,
            Form_CancelButton: currentForm[0].Form_CancelButton_disable === 'True' || null,
            loading: false
        });
        !currentForm[0].Form_ClienstSideRules && this.handleAddColumn(0)
    }

    handleClose = (name) => {
        this.setState({ [name]: false });
    };

    handleFormSettingsChange(target) {
        this.setState({ [target.name]: target.value })
    }

    async handleFormSettingsSave() {
        let { data } = await saveFormSettings(this.state);
        if (data.includes('Success')) {
            toaster('success', 'Form Settings Saved')
            this.setState({ show: false })
        }
        else {
            toaster('error', 'Form Settings Save failed')
        }
    }

    handleAddColumn() {
        const Form_ClienstSideRules = [...this.state.Form_ClienstSideRules, { 'Rule_ID': this.state.Form_ClienstSideRules.length, 'Rule_Text': '' }];
        this.setState({ Form_ClienstSideRules });
    }

    handleRemoveColumn(idx) {
        let Form_ClienstSideRules = this.state.Form_ClienstSideRules.filter(function (col, index) {
            return index !== idx;
        });
        Form_ClienstSideRules.map((rule, idx) => {
            rule['Rule_ID'] = idx
        })
        this.setState({ Form_ClienstSideRules });
    }

    handleChange = (input, idx) => {
        this.setState({ [input.name]: input.value });
        let Form_ClienstSideRules = this.state.Form_ClienstSideRules
        Form_ClienstSideRules.map((rule) => {
            if (rule['Rule_ID'] === idx) {
                rule['Rule_Text'] = input.value
            }
        })
        this.setState({ Form_ClienstSideRules })
    };

    handleDefaultButtonSwitch = (target) => {
        this.setState({ [target.name]: !this.state[target.name] });
    };

    render() {
        const { Form_SaveButton, Form_CancelButton } = this.state;
        if (this.state.loading) {
            return <CustomLoader loading={this.state.loading} />;
        }
        return (
            <React.Fragment>
                <Modal size='lg' show={this.state.show} onHide={() => this.handleClose("show")}>
                    <Modal.Header className="card-header font-weight-bold text-primary" closeButton>
                        Form Settings
                    </Modal.Header>
                    <Modal.Body>
                        <div>
                            <div className="form-group">
                                <label>Disable Default Buttons</label>
                                <div className="custom-control custom-switch">
                                    <input type="checkbox" id="id_Form_SaveButton" name="Form_SaveButton" className="custom-control-input" checked={Form_SaveButton} value={Form_SaveButton} onChange={(e) => this.handleDefaultButtonSwitch(e.target)} />
                                    <label id="label_Form_SaveButton" name="labelId_SaveButton" htmlFor="id_Form_SaveButton" className="custom-control-label">Save</label>
                                    <span>
                                        <input type="checkbox" id="id_Form_CancelButton" name="Form_CancelButton" className="custom-control-input" checked={Form_CancelButton} value={Form_CancelButton} onChange={(e) => this.handleDefaultButtonSwitch(e.target)} />
                                        <label id="label_Form_CancelButton" name="labelId_CancelButton" htmlFor="id_Form_CancelButton" className="custom-control-label ml-10">Cancel</label>
                                    </span>
                                </div>
                            </div>
                            <div className="form-group">
                                <label htmlFor="Form_BehaviorOnSave">Save Action</label>
                                <select
                                    type="text"
                                    className="form-control"
                                    id="Form_BehaviorOnSave"
                                    name="Form_BehaviorOnSave"
                                    value={this.state.Form_BehaviorOnSave}
                                    onChange={(e) => this.handleFormSettingsChange(e.target)}
                                >
                                    <option key='0' value={0}>- Select -</option>
                                    <option key='2' value={2}>Clear Form</option>
                                    <option key='1' value={1}>Redirect Form</option>
                                    <option key='3' value={3}>No Action</option>
                                </select>
                            </div>
                            {(this.state.Form_BehaviorOnSave).includes('1') &&
                                <div className="form-group">
                                    <label htmlFor="Form_RedirectTo">Redirect To</label>
                                    <select
                                        id="Form_RedirectTo"
                                        className="form-control"
                                        name='Form_RedirectTo'
                                        value={this.state.Form_RedirectTo}
                                        onChange={(e) => this.handleFormSettingsChange(e.target)}
                                    >
                                        <option key='-1'>- Select -</option>
                                        {this.Forms.map((form) => {
                                            return (
                                                <option key={form.Form_ID} value={form.Form_ID}>
                                                    {form.Form_Name}
                                                </option>
                                            );
                                        })}
                                    </select>
                                </div>
                            }
                            <div className="form-group">
                                <label htmlFor="Form_CustomValidationSP">Custom Server Side Validation</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="Form_CustomValidationSP"
                                    name="Form_CustomValidationSP"
                                    placeholder="Enter Stored Procedure Name"
                                    value={this.state.Form_CustomValidationSP}
                                    onChange={(e) => this.handleFormSettingsChange(e.target)}
                                />
                            </div>
                            <label htmlFor="Form_ClientValidation">Custom Client Side Validation</label>
                            <button className='btn btn-outline-primary btn-icon btn-sm mr-2 ml-2 float-right' onClick={() => this.handleAddColumn()}>
                                <Icon.Plus size={20} />
                            </button>
                            <div className="form-group scroll">
                                {this.state.Form_ClienstSideRules.map((rule, idx) => {
                                    return (
                                        <div>
                                            <label htmlFor="Form_ClientValidation" className="text-primary mt-2">Rule #{idx + 1}</label>
                                            {idx >= 1 && (
                                                <button className='btn btn-outline-danger btn-icon btn-sm ml-2 float-right mt-2 mb-2' onClick={() => this.handleRemoveColumn(idx)}>
                                                    <Icon.Minus size={20} />
                                                </button>
                                            )}
                                            <textarea name={"Form_ClientValidation" + idx} id="Form_ClientValidation" className="form-control" rows={5} onChange={(e) => this.handleChange(e.target, idx)}
                                                placeholder=' Sample Format:
                                                            START #4
                                                            IF #1=No AND #2=Missing AND #3=Yes
                                                            SHOW #4
                                                            IF #1=Yes OR #2=Missing OR #3=OK
                                                            HIDE #4
                                                            END'
                                                value={rule.Rule_Text}
                                            >
                                            </textarea>
                                        </div>
                                    )
                                }
                                )}
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button className="btn btn-primary" onClick={this.handleFormSettingsSave}>
                            Save
                        </button>
                    </Modal.Footer>
                </Modal>
            </React.Fragment>
        );
    }
}

export default FormSettings;